import { RevealDealerEnquiryModal } from '../../../../../components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal';
import { RevealSendMessage } from '../../../../../components/PageWrappers/SharedComponents/RevealSendMessage/RevealSendMessage';
import type { EmailDealerOrSellerProps } from '../../../../../components/PageWrappers/AdDetails/components/EmailDealerOrSeller/EmailDealerOrSeller.typed';
import { SELLER_TYPES } from '../../types';

const EmailDealerOrSeller = (props: EmailDealerOrSellerProps) => {
  const { adId, sellerType, handleReveal, clickSource, dealerID } = props;

  return (
    <>
      {sellerType === SELLER_TYPES.DEALER ? (
        <RevealDealerEnquiryModal
          adId={adId}
          id={dealerID}
          handleReveal={handleReveal}
        />
      ) : (
        <RevealSendMessage adId={adId} clickSource={clickSource} />
      )}
    </>
  );
};

export { EmailDealerOrSeller };
